// Components
import { EnvelopeIconType } from '@atoms/index';
// Utils
import text from '@translations/en.json';
// Types
import { ForgotPasswordStateMachine } from './ForgotPasswordCard.type';

/**
 * Represents the state elements for the ForgotPasswordState.
 */
export const stateMachine: ForgotPasswordStateMachine = {
  INITIAL: {
    title: text.forgot_password_title,
    message: () => text.forgot_password_message,
    confirmation: '',
    envelopeType: EnvelopeIconType.DEFAULT,
  },
  EMAIL_SENT: {
    title: text.forgot_password_title_sent,
    message: (username?: string) =>
      `${text.forgot_password_message_sent_initial} ${username}${text.forgot_password_message_sent_final}`,
    confirmation: text.forgot_password_confirmation,
    envelopeType: EnvelopeIconType.CHECK,
  },
  FORCED_RETRY: {
    title: text.forgot_password_title_sent,
    message: (username?: string) =>
      `${text.forgot_password_message_sent_initial} ${username}${text.forgot_password_message_sent_final}`,
    confirmation: text.forgot_password_confirmation_resend,
    envelopeType: EnvelopeIconType.CHECK,
  },
};
